@if (!store.isSummary) {
    <ap-previous-button (click)="previousQuestion()"></ap-previous-button>
    <div class="bold">{{ 'financial-obligations.student-debt.title' | apContent }}</div>
}

@if (showStudentDebtMonthlyAmount()) {
    <student-debt-amount></student-debt-amount>
}
